export default __webpack_public_path__ + "static/service-2079beeb59ee2e256784cf18a3a02f8a.png";